// Color design tokens for dark mode (black with gray)
export const tokensDark = {
    grey: {
      0: "#ffffff", // White
      100: "#e0e0e0", // Light gray
      200: "#c2c2c2",
      300: "#a3a3a3",
      400: "#858585",
      500: "#666666", // Medium gray
      600: "#525252",
      700: "#3d3d3d",
      800: "#292929",
      900: "#141414", // Dark gray
      1000: "#000000", // Black
    },
    primary: {
      100: "#ffffff", // White for text or highlights
      200: "#e0e0e0", // Light gray for secondary text
      300: "#b0b0b0", // Medium gray for borders or less emphasized text
      400: "#808080", // Dark gray for general UI elements
      500: "#4d4d4d", // Darker gray for backgrounds or cards
      600: "#333333", // Very dark gray for primary backgrounds
      700: "#1a1a1a", // Almost black for deeper backgrounds
      800: "#0d0d0d", // Near black for overlays or modal backgrounds
      900: "#000000", // Pure black
    },
    secondary: {
      100: "#f0f0f0", // Light gray for secondary elements
      200: "#d9d9d9",
      300: "#bfbfbf",
      400: "#a6a6a6",
      500: "#8c8c8c", // Medium gray for secondary highlights
      600: "#737373",
      700: "#595959",
      800: "#404040",
      900: "#262626", // Dark gray for secondary elements
    },
  };
  
  // Color design tokens for light mode (white)
  export const tokensLight = {
    grey: {
      0: "#000000", // Black
      100: "#141414", // Dark gray
      200: "#292929",
      300: "#3d3d3d",
      400: "#525252",
      500: "#666666", // Medium gray
      600: "#858585",
      700: "#a3a3a3",
      800: "#c2c2c2",
      900: "#e0e0e0", // Light gray
      1000: "#ffffff", // White
    },
    primary: {
      100: "#000000", // Black for text or highlights
      200: "#1a1a1a", // Very dark gray for primary backgrounds
      300: "#333333", // Dark gray for general UI elements
      400: "#4d4d4d", // Darker gray for backgrounds or cards
      500: "#808080", // Medium gray for borders or less emphasized text
      600: "#b0b0b0", // Light gray for secondary text
      700: "#d9d9d9", // Very light gray for highlights
      800: "#f0f0f0", // Near white for overlays or modal backgrounds
      900: "#ffffff", // Pure white
    },
    secondary: {
      100: "#262626", // Dark gray for secondary elements
      200: "#404040",
      300: "#595959",
      400: "#737373",
      500: "#8c8c8c", // Medium gray for secondary highlights
      600: "#a6a6a6",
      700: "#bfbfbf",
      800: "#d9d9d9",
      900: "#f0f0f0", // Light gray for secondary elements
    },
  };
  
  // MUI theme settings
  export const themeSettings = (mode) => {
    return {
      palette: {
        mode: mode,
        ...(mode === "dark"
          ? {
              // Palette values for dark mode
              maincolor:{
                light:'white', // Light gray for secondary text
                buttoncolor:'linear-gradient(to right, rgb(155, 57, 19), rgb(185, 80, 71))',
                sidebartheme:tokensDark.primary[600]
              },
              primary: {
                ...tokensDark.primary,
                main:tokensDark.primary[100], // Main container text color for dark mode
                light: tokensDark.primary[400], // Lighter elements
              },
              secondary: {
                ...tokensDark.secondary,
                main: tokensDark.secondary[500], // Secondary highlights
              },
              neutral: {
                ...tokensDark.grey,
                main: tokensDark.grey[500], // Neutral elements
              },
              background: {
                default: tokensDark.primary[700], // Default background
                alt: tokensDark.primary[500], // Alternate background
              },
            }
          : {
            maincolor:{
              light:'rgb(155, 19, 74)', // Updated primary color
              morelight:'rgb(185, 80, 71)', // Lighter elements
              buttoncolor:'white',
              sidebartheme:'linear-gradient(to right, rgb(155, 57, 19), rgb(185, 80, 71))' // Updated gradient
            },
              // Palette values for light mode
              primary: {
                ...tokensLight.primary,
                main:tokensLight.primary[100], // Main container text color for light mode
                light: tokensLight.primary[200], // Lighter elements
                
              },
              secondary: {
                ...tokensLight.secondary,
                main: tokensLight.secondary[300], // Secondary highlights
              },
              neutral: {
                ...tokensLight.grey,
                main: tokensLight.grey[500], // Neutral elements
              },
              background: {
                default:  tokensLight.primary[800], // Default background
                alt: tokensLight.primary[900], // Alternate background
              },
            }),
      },
    };
  };